
import Vue, { PropType } from 'vue';
import { CvToastNotification } from '@carbon/vue';
import {
  NotificationResult,
  ToastNotification,
} from '../../typings/notification';
import { mapToastNotification } from '../../../../utils/notificationMapper';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { mapState } from 'pinia';

export default Vue.extend({
  name: 'NotificationToast',

  components: {
    CvToastNotification,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationResult>,
      required: true,
    },
  },
  computed: {
    ...mapState(useShapeStore, ['shapeById']),

    toastNotification(): ToastNotification | undefined {
      if (this.notification.shapeId) {
        const shape = this.shapeById(this.notification.shapeId);
        return mapToastNotification(this.notification, shape);
      }
      return mapToastNotification(this.notification, undefined);
    },
  },
});
